const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1631_66217",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1631_66217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2077 21.9585L15.166 18.7918C14.916 18.514 14.6105 18.3752 14.2493 18.3752C13.8882 18.3752 13.5688 18.5002 13.291 18.7502C13.0132 19.0279 12.8743 19.3474 12.8743 19.7085C12.8743 20.0696 13.0132 20.389 13.291 20.6668L17.3327 24.6668C17.5827 24.9168 17.8743 25.0418 18.2077 25.0418C18.541 25.0418 18.8327 24.9168 19.0827 24.6668L26.7077 17.0835C26.9577 16.8335 27.0827 16.5279 27.0827 16.1668C27.0827 15.8057 26.9438 15.5002 26.666 15.2502C26.416 15.0279 26.1174 14.9238 25.7702 14.9377C25.423 14.9515 25.1382 15.0696 24.916 15.2918L18.2077 21.9585ZM13.8327 36.5002L11.2493 32.0835L6.08268 31.0418C5.77713 30.9863 5.52018 30.8196 5.31185 30.5418C5.10352 30.264 5.02713 29.9724 5.08268 29.6668L5.66602 24.6668L2.37435 20.8335C2.15213 20.6113 2.04102 20.3335 2.04102 20.0002C2.04102 19.6668 2.15213 19.389 2.37435 19.1668L5.66602 15.3752L5.08268 10.3752C5.02713 10.0696 5.10352 9.77793 5.31185 9.50015C5.52018 9.22238 5.77713 9.05571 6.08268 9.00015L11.2493 7.95849L13.8327 3.50015C13.9993 3.22238 14.2355 3.02793 14.541 2.91682C14.8466 2.80571 15.1521 2.8196 15.4577 2.95849L19.9993 5.08349L24.541 2.95849C24.8466 2.8196 25.1521 2.79876 25.4577 2.89599C25.7632 2.99321 25.9994 3.18071 26.166 3.45849L28.791 7.95849L33.916 9.00015C34.2216 9.05571 34.4785 9.22238 34.6869 9.50015C34.8952 9.77793 34.9716 10.0696 34.916 10.3752L34.3327 15.3752L37.6244 19.1668C37.8466 19.389 37.9577 19.6668 37.9577 20.0002C37.9577 20.3335 37.8466 20.6113 37.6244 20.8335L34.3327 24.6668L34.916 29.6668C34.9716 29.9724 34.8952 30.264 34.6869 30.5418C34.4785 30.8196 34.2216 30.9863 33.916 31.0418L28.791 32.0835L26.166 36.5418C25.9994 36.8196 25.7632 37.0071 25.4577 37.1043C25.1521 37.2015 24.8466 37.1807 24.541 37.0418L19.9993 34.9168L15.4577 37.0418C15.1521 37.1807 14.8466 37.1946 14.541 37.0835C14.2355 36.9724 13.9993 36.7779 13.8327 36.5002Z",
    fill: "#319300",
    style: {
      fill: "#319300",
      fill: "color(display-p3 0.1922 0.5765 0.0000)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon_success.8fe55061c4db53badb690eb43ec7cc7e.svg";
export { ForwardRef as ReactComponent };